import { render, staticRenderFns } from "./borusan.vue?vue&type=template&id=e9fac400&scoped=true"
import script from "./borusan.vue?vue&type=script&lang=js"
export * from "./borusan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fac400",
  null
  
)

export default component.exports